import { generateSpanWithDataTestId } from '@app/shared/utils';

import type { RuleObject } from 'antd/es/form';

export const REGISTRY_SEARCH_RULES = {
  search: [
    {
      validator: (_: RuleObject, value: string) => {
        const trimmedQuery = value?.trim() || '';
        const minLength = 3;
        const maxLength = 300;
        const isLessThanMinLength = trimmedQuery.length < minLength;
        const isMoreThanMaxLength = trimmedQuery.length > maxLength;

        if (isMoreThanMaxLength) {
          return Promise.reject('Превышено максимальное количество символов');
        }

        if (value?.length && isLessThanMinLength) {
          return Promise.reject(
            generateSpanWithDataTestId(
              `Минимум символов: ${minLength}`,
              'alert'
            )
          );
        }

        return Promise.resolve();
      },
    },
  ],
};
